const categorySortOptions = document.querySelectorAll(".faq-categories .faq-category-sort");
const categories = document.querySelector(".faqs");
const categoryRawData = categories.getAttribute('data-faq-category');
const categoryData = JSON.parse(categoryRawData);

const faqSearchInput = document.querySelector('#faq-search-input');
const faqSuggestions = document.querySelector('#faq-suggestions');
const allFaqs = Array.from(document.querySelectorAll('.faq-category .accordion'));

const categoryElems = {};

categoryData.forEach(cat => {
const elems = document.querySelectorAll(`[data-faq-id="${cat}"]`);
categoryElems[cat] = elems;
});

categorySortOptions.forEach(categorySortOption => {
    categorySortOption.addEventListener("click", () => {
        const selectedCategory = categorySortOption.textContent.trim();

        document.querySelectorAll("[data-faq-id]").forEach(el => el.style.display = "none");

        const matchedElems = categoryElems[selectedCategory];

        if (matchedElems && matchedElems.length > 0) {
        matchedElems.forEach(el => {
            el.style.display = "block";
        });
        } else {
        console.warn(`No FAQs found for category: ${selectedCategory}`);
        }
    });
});

faqSearchInput.addEventListener('input', function() {
    const query = this.value.trim().toLowerCase();

    faqSuggestions.innerHTML = '';

    if (!query) {
        faqSuggestions.classList.remove('visible');
        return;
    }

    const matches = [];

    allFaqs.forEach(faq => {
        const question = faq.querySelector('summary')?.textContent.trim() || '';
        const answer = faq.querySelector('.accordion__content')?.textContent.trim() || '';
        const category = faq.closest('.faq-category')?.querySelector('.category-title')?.textContent.trim() || '';

        if (
        question.toLowerCase().includes(query) ||
        answer.toLowerCase().includes(query) ||
        category.toLowerCase().includes(query)
        ) {
            matches.push({
                question,
                category,
                element: faq
            });
        }
    });

    if (matches.length === 0) {
        faqSuggestions.innerHTML = '<li>No results found</li>';
    } 
    else {
        matches.forEach(match => {
        const li = document.createElement('li');
        li.innerHTML = `<strong>${match.question}</strong><br><small>${match.category}</small>`;
        li.addEventListener('click', () => {
            faqSuggestions.classList.remove('visible');
            faqSearchInput.value = match.question;
            document.querySelectorAll('[data-faq-id]').forEach(el => el.style.display = 'none');
            match.element.closest('.faq-category').style.display = 'block';
            const details = match.element.querySelector('details');
            details.setAttribute('open', 'true');
            match.element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
        faqSuggestions.appendChild(li);
        });
    }

    faqSuggestions.classList.add('visible');
});

document.addEventListener('click', (e) => {
    if (!e.target.closest('.section-searchbar-wrapper') && !e.target.closest('#faq-suggestions')) {
        faqSuggestions.classList.remove('visible');
    }
});